import './../../css/blocks/content-result.pcss';
